/**
 * @generated SignedSource<<09236998b2bbe9378d8e8cd967986af4>>
 * @relayHash ecbd6fa17ec00de4901cd6f361c8e5a7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b106f8974443976a3ba89da95c938ac40473dc9d075a7590278530c4bec67053

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ClassificationLevelSource = "AUTO" | "CONTENT" | "NONE" | "ORGANIZATION" | "SPACE" | "%future added value";
export type ContentStateRestrictionLevel = "NONE" | "PAGE_OWNER" | "%future added value";
export type ContentUnifiedQuery$variables = {
  agentSessionsPropertyKey?: string | null;
  bylineContributorsLimit?: number | null;
  contentId: string;
  fetchAgentSessionsMarker?: boolean | null;
  includeAgentTrustReceiptData?: boolean | null;
  includeArchiveMetadata?: boolean | null;
  includeBylineContributors?: boolean | null;
  includeClassification?: boolean | null;
  includeReactions?: boolean | null;
  includeRestrictionAncestors?: boolean | null;
  includeRestrictions?: boolean | null;
  isSSR?: boolean | null;
  preloadLabels?: boolean | null;
  spaceKey?: string | null;
  useNewContentTopper?: boolean | null;
  versionOverride?: number | null;
};
export type ContentUnifiedQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly agentSessionsMarker?: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly appearancePublished: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly archivedPageBanner?: {
        readonly archivedContentMetadata: {
          readonly archiveNote: string | null;
        } | null;
        readonly history: {
          readonly lastUpdated: {
            readonly by: {
              readonly accountId?: string | null;
            } | null;
          } | null;
        } | null;
        readonly id: string | null;
        readonly operations: ReadonlyArray<{
          readonly operation: string | null;
          readonly targetType: string | null;
        } | null> | null;
        readonly type: string | null;
      } | null;
      readonly archivedPageBannerFragment?: {
        readonly " $fragmentSpreads": FragmentRefs<"ArchivedPageBannerV2_content">;
      } | null;
      readonly archivedPageBannerStatusFragment?: {
        readonly " $fragmentSpreads": FragmentRefs<"ArchivedPageBannerV2Status_content">;
      } | null;
      readonly body: {
        readonly dynamic: {
          readonly content: {
            readonly id: string | null;
            readonly version: {
              readonly number: number | null;
            } | null;
          } | null;
          readonly representation: string | null;
          readonly value: string | null;
          readonly webresource: {
            readonly superbatch: {
              readonly tags: {
                readonly css: string | null;
                readonly js: string | null;
              } | null;
            } | null;
            readonly tags: {
              readonly css: string | null;
              readonly js: string | null;
            } | null;
          } | null;
        } | null;
      } | null;
      readonly contentClassification?: {
        readonly classificationLevelDetails: {
          readonly canManageSpaceSettings: boolean;
          readonly classificationControlSetting: string | null;
          readonly classificationLevel: {
            readonly color: string | null;
            readonly description: string | null;
            readonly guideline: string | null;
            readonly guidelineADF: string | null;
            readonly id: string;
            readonly name: string;
            readonly status: string;
          } | null;
          readonly featureEnabled: boolean;
          readonly isReclassificationPermitted: boolean;
          readonly source: ClassificationLevelSource | null;
          readonly userOverrideSetting: string | null;
        } | null;
        readonly id: string | null;
      } | null;
      readonly contentClassificationFragment?: {
        readonly " $fragmentSpreads": FragmentRefs<"useContentClassification_content">;
      } | null;
      readonly contentProperties: {
        readonly draft: {
          readonly contentMode: string | null;
        } | null;
        readonly latest: {
          readonly contentMode: string | null;
          readonly generatedBy?: string | null;
        } | null;
      } | null;
      readonly contentState: {
        readonly color: string;
        readonly id: string | null;
        readonly name: string;
        readonly restrictionLevel: ContentStateRestrictionLevel;
      } | null;
      readonly contentStateLastUpdated: {
        readonly value: string;
      } | null;
      readonly contentTitleWithByLine?: {
        readonly " $fragmentSpreads": FragmentRefs<"ContentTitleWithByLine_content">;
      } | null;
      readonly coverPicture?: {
        readonly coverPictureProperties: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly key: string | null;
            readonly value: string | null;
            readonly version: {
              readonly number: number | null;
            } | null;
          } | null> | null;
        } | null;
        readonly id: string | null;
      } | null;
      readonly draftVersion: {
        readonly by: {
          readonly displayName: string | null;
        } | null;
        readonly contentTypeModified: boolean | null;
        readonly friendlyWhen: string | null;
        readonly number: number | null;
        readonly when: string | null;
      } | null;
      readonly history?: {
        readonly createdBy: {
          readonly displayName: string | null;
        } | null;
        readonly createdDate: string | null;
      } | null;
      readonly id: string | null;
      readonly labels?: {
        readonly count: number | null;
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly label: string | null;
          readonly name: string | null;
          readonly prefix: string | null;
        } | null> | null;
      } | null;
      readonly macroRenderedOutput?: ReadonlyArray<{
        readonly key: string | null;
        readonly value: {
          readonly representation: string | null;
          readonly value: string | null;
          readonly webresource: {
            readonly tags: {
              readonly css: string | null;
              readonly js: string | null;
            } | null;
          } | null;
        } | null;
      } | null> | null;
      readonly metadata: {
        readonly frontend: {
          readonly collabService: string | null;
          readonly coverPictureWidth?: string | null;
          readonly embedded: boolean;
          readonly fabricEditorSupported: boolean | null;
        } | null;
        readonly lastModifiedDate: string | null;
      };
      readonly operations: ReadonlyArray<{
        readonly operation: string | null;
        readonly targetType: string | null;
      } | null> | null;
      readonly pageRestrictionsContext?: {
        readonly hasInheritedRestrictions: boolean;
        readonly hasRestrictions: boolean;
        readonly hasViewRestrictions: boolean;
        readonly id: string | null;
      } | null;
      readonly pageRestrictionsContextAncestors?: {
        readonly ancestors: ReadonlyArray<{
          readonly hasRestrictions: boolean;
          readonly id: string | null;
          readonly links: {
            readonly webui: string | null;
          } | null;
          readonly title: string | null;
        } | null> | null;
        readonly id: string | null;
      } | null;
      readonly pageTitlePublished?: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly properties: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly reactionsContent?: {
        readonly contentReactionsSummary: {
          readonly ari: string;
          readonly containerAri: string;
          readonly reactionsCount: number;
          readonly reactionsSummaryForEmoji: ReadonlyArray<{
            readonly count: number;
            readonly emojiId: string;
            readonly id: string;
            readonly reacted: boolean;
          } | null>;
        } | null;
        readonly id: string | null;
      } | null;
      readonly shareAndRestrictButtonData?: {
        readonly hasInheritedRestrictions: boolean;
        readonly hasRestrictions: boolean;
        readonly hasViewRestrictions: boolean;
        readonly id: string | null;
        readonly title: string | null;
      } | null;
      readonly smartFolderProperties: {
        readonly nodes: ReadonlyArray<{
          readonly key: string | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly space: {
        readonly alias: string | null;
        readonly id: string | null;
        readonly key: string | null;
        readonly name: string | null;
      } | null;
      readonly status: string | null;
      readonly subType: string | null;
      readonly title: string | null;
      readonly titleContentProperties?: {
        readonly id: string | null;
        readonly metadata: {
          readonly frontend: {
            readonly coverPictureWidth: string | null;
          } | null;
        };
        readonly pageTitleDraft: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly key: string | null;
            readonly value: string | null;
            readonly version: {
              readonly number: number | null;
            } | null;
          } | null> | null;
        } | null;
        readonly pageTitlePublished: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly key: string | null;
            readonly value: string | null;
            readonly version: {
              readonly number: number | null;
            } | null;
          } | null> | null;
        } | null;
      } | null;
      readonly type: string | null;
      readonly version: {
        readonly by: {
          readonly displayName: string | null;
        } | null;
        readonly confRev: string | null;
        readonly contentTypeModified: boolean | null;
        readonly friendlyWhen: string | null;
        readonly number: number | null;
        readonly when: string | null;
      } | null;
      readonly viewPageLabels?: {
        readonly " $fragmentSpreads": FragmentRefs<"ViewPageLabelsContentFragment_content">;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"ContentOperationsFragment" | "PageStatusQueryRelaySpike_content" | "PresenterModePortal_content">;
    } | null> | null;
  } | null;
  readonly contentContributors?: {
    readonly " $fragmentSpreads": FragmentRefs<"ByLineContributors_contentContributors">;
  } | null;
  readonly space: {
    readonly currentUser: {
      readonly isAnonymouslyAuthorized: boolean;
    };
    readonly id: string | null;
    readonly lookAndFeel: {
      readonly content: {
        readonly container: {
          readonly background: string | null;
          readonly backgroundAttachment: string | null;
          readonly backgroundBlendMode: string | null;
          readonly backgroundClip: string | null;
          readonly backgroundColor: string | null;
          readonly backgroundImage: string | null;
          readonly backgroundOrigin: string | null;
          readonly backgroundPosition: string | null;
          readonly backgroundRepeat: string | null;
          readonly backgroundSize: string | null;
          readonly borderRadius: string | null;
          readonly padding: string | null;
        } | null;
        readonly screen: {
          readonly background: string | null;
          readonly backgroundAttachment: string | null;
          readonly backgroundBlendMode: string | null;
          readonly backgroundClip: string | null;
          readonly backgroundColor: string | null;
          readonly backgroundImage: string | null;
          readonly backgroundOrigin: string | null;
          readonly backgroundPosition: string | null;
          readonly backgroundRepeat: string | null;
          readonly backgroundSize: string | null;
          readonly gutterBottom: string | null;
          readonly gutterLeft: string | null;
          readonly gutterRight: string | null;
          readonly gutterTop: string | null;
          readonly layer: {
            readonly background: string | null;
            readonly backgroundAttachment: string | null;
            readonly backgroundBlendMode: string | null;
            readonly backgroundClip: string | null;
            readonly backgroundColor: string | null;
            readonly backgroundImage: string | null;
            readonly backgroundOrigin: string | null;
            readonly backgroundPosition: string | null;
            readonly backgroundRepeat: string | null;
            readonly backgroundSize: string | null;
            readonly height: string | null;
            readonly width: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
    readonly settings: {
      readonly routeOverrideEnabled: boolean | null;
    } | null;
    readonly theme: {
      readonly name: string | null;
      readonly themeKey: string | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"ContentContainerTheme_space" | "ContentTitle_space">;
  } | null;
};
export type ContentUnifiedQuery = {
  response: ContentUnifiedQuery$data;
  variables: ContentUnifiedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "agentSessionsPropertyKey"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bylineContributorsLimit"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchAgentSessionsMarker"
},
v4 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeAgentTrustReceiptData"
},
v5 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeArchiveMetadata"
},
v6 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeBylineContributors"
},
v7 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeClassification"
},
v8 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeReactions"
},
v9 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeRestrictionAncestors"
},
v10 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeRestrictions"
},
v11 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isSSR"
},
v12 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "preloadLabels"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v14 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "useNewContentTopper"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "versionOverride"
},
v16 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "contentId"
},
v17 = [
  (v16/*: any*/),
  {
    "kind": "Variable",
    "name": "version",
    "variableName": "versionOverride"
  }
],
v18 = {
  "kind": "ScalarField",
  "name": "id"
},
v19 = {
  "kind": "ScalarField",
  "name": "status"
},
v20 = [
  {
    "kind": "ScalarField",
    "name": "contentMode"
  }
],
v21 = {
  "concreteType": "ContentProperties",
  "kind": "LinkedField",
  "name": "contentProperties",
  "plural": false,
  "selections": [
    {
      "concreteType": "PublishedContentProperties",
      "kind": "LinkedField",
      "name": "latest",
      "plural": false,
      "selections": (v20/*: any*/)
    },
    {
      "concreteType": "DraftContentProperties",
      "kind": "LinkedField",
      "name": "draft",
      "plural": false,
      "selections": (v20/*: any*/)
    }
  ]
},
v22 = {
  "kind": "ScalarField",
  "name": "name"
},
v23 = {
  "kind": "ScalarField",
  "name": "color"
},
v24 = {
  "args": [
    {
      "kind": "Literal",
      "name": "isDraft",
      "value": false
    }
  ],
  "concreteType": "ContentState",
  "kind": "LinkedField",
  "name": "contentState",
  "plural": false,
  "selections": [
    (v18/*: any*/),
    (v22/*: any*/),
    (v23/*: any*/),
    {
      "kind": "ScalarField",
      "name": "restrictionLevel"
    }
  ],
  "storageKey": "contentState(isDraft:false)"
},
v25 = {
  "kind": "ScalarField",
  "name": "value"
},
v26 = {
  "args": [
    {
      "kind": "Literal",
      "name": "format",
      "value": "USER_FRIENDLY"
    }
  ],
  "concreteType": "ConfluenceDate",
  "kind": "LinkedField",
  "name": "contentStateLastUpdated",
  "plural": false,
  "selections": [
    (v25/*: any*/)
  ],
  "storageKey": "contentStateLastUpdated(format:\"USER_FRIENDLY\")"
},
v27 = {
  "kind": "ScalarField",
  "name": "title"
},
v28 = {
  "concreteType": "OperationCheckResult",
  "kind": "LinkedField",
  "name": "operations",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "operation"
    },
    {
      "kind": "ScalarField",
      "name": "targetType"
    }
  ]
},
v29 = {
  "kind": "ScalarField",
  "name": "key"
},
v30 = {
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v18/*: any*/),
    (v22/*: any*/),
    (v29/*: any*/),
    {
      "kind": "ScalarField",
      "name": "alias"
    }
  ]
},
v31 = {
  "kind": "ScalarField",
  "name": "type"
},
v32 = {
  "kind": "ScalarField",
  "name": "subType"
},
v33 = [
  (v29/*: any*/),
  (v25/*: any*/)
],
v34 = {
  "alias": "smartFolderProperties",
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "smartFolderProperties"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": (v33/*: any*/)
    }
  ],
  "storageKey": "properties(keys:[\"smartFolderProperties\"])"
},
v35 = {
  "kind": "ScalarField",
  "name": "contentTypeModified"
},
v36 = {
  "kind": "ScalarField",
  "name": "number"
},
v37 = {
  "kind": "ScalarField",
  "name": "friendlyWhen"
},
v38 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v39 = [
  (v38/*: any*/)
],
v40 = {
  "kind": "LinkedField",
  "name": "by",
  "plural": false,
  "selections": (v39/*: any*/)
},
v41 = {
  "kind": "ScalarField",
  "name": "when"
},
v42 = {
  "kind": "ScalarField",
  "name": "confRev"
},
v43 = [
  {
    "kind": "ScalarField",
    "name": "coverPictureWidth"
  }
],
v44 = {
  "concreteType": "ContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
      "kind": "LinkedField",
      "name": "frontend",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "fabricEditorSupported"
        },
        {
          "kind": "ScalarField",
          "name": "embedded"
        },
        {
          "kind": "ScalarField",
          "name": "collabService"
        },
        {
          "condition": "useNewContentTopper",
          "kind": "Condition",
          "passingValue": true,
          "selections": (v43/*: any*/)
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "lastModifiedDate"
    }
  ]
},
v45 = {
  "kind": "ScalarField",
  "name": "representation"
},
v46 = {
  "concreteType": "Version",
  "kind": "LinkedField",
  "name": "version",
  "plural": false,
  "selections": [
    (v36/*: any*/)
  ]
},
v47 = {
  "concreteType": "WebResourceTags",
  "kind": "LinkedField",
  "name": "tags",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "js"
    },
    {
      "kind": "ScalarField",
      "name": "css"
    }
  ]
},
v48 = [
  (v47/*: any*/)
],
v49 = {
  "concreteType": "ContentBodyPerRepresentation",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": [
    {
      "concreteType": "ContentBody",
      "kind": "LinkedField",
      "name": "dynamic",
      "plural": false,
      "selections": [
        (v45/*: any*/),
        (v25/*: any*/),
        {
          "concreteType": "Content",
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            (v18/*: any*/),
            (v46/*: any*/)
          ]
        },
        {
          "concreteType": "WebResourceDependencies",
          "kind": "LinkedField",
          "name": "webresource",
          "plural": false,
          "selections": [
            {
              "concreteType": "SuperBatchWebResources",
              "kind": "LinkedField",
              "name": "superbatch",
              "plural": false,
              "selections": (v48/*: any*/)
            },
            (v47/*: any*/)
          ]
        }
      ]
    }
  ]
},
v50 = [
  {
    "concreteType": "JsonContentProperty",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v18/*: any*/),
      (v29/*: any*/),
      (v25/*: any*/),
      (v46/*: any*/)
    ]
  }
],
v51 = {
  "alias": "appearancePublished",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "content-appearance-published"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v50/*: any*/),
  "storageKey": "properties(key:\"content-appearance-published\")"
},
v52 = {
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "cover-picture-id-published",
        "emoji-title-published",
        "editor",
        "import-source",
        "imported-page-modified-date"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v50/*: any*/),
  "storageKey": "properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"])"
},
v53 = {
  "concreteType": "ArchivedContentMetadata",
  "kind": "LinkedField",
  "name": "archivedContentMetadata",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "archiveNote"
    }
  ]
},
v54 = [
  {
    "kind": "ScalarField",
    "name": "accountId"
  }
],
v55 = {
  "kind": "InlineFragment",
  "selections": (v54/*: any*/),
  "type": "KnownUser"
},
v56 = {
  "kind": "InlineFragment",
  "selections": (v54/*: any*/),
  "type": "UnknownUser"
},
v57 = {
  "alias": "pageTitlePublished",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "page-title-property-published"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v50/*: any*/),
  "storageKey": "properties(key:\"page-title-property-published\")"
},
v58 = {
  "alias": "pageTitleDraft",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "page-title-property-draft"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v50/*: any*/),
  "storageKey": "properties(key:\"page-title-property-draft\")"
},
v59 = {
  "concreteType": "ContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
      "kind": "LinkedField",
      "name": "frontend",
      "plural": false,
      "selections": (v43/*: any*/)
    }
  ]
},
v60 = {
  "alias": "coverPictureProperties",
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "cover-picture-id-draft",
        "cover-picture-id-published"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v50/*: any*/),
  "storageKey": "properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"])"
},
v61 = {
  "kind": "ScalarField",
  "name": "hasInheritedRestrictions"
},
v62 = {
  "kind": "ScalarField",
  "name": "hasRestrictions"
},
v63 = {
  "kind": "ScalarField",
  "name": "hasViewRestrictions"
},
v64 = [
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": {
      "direction": "ASCENDING",
      "sortField": "LABELLING_CREATIONDATE"
    }
  }
],
v65 = {
  "kind": "ScalarField",
  "name": "count"
},
v66 = {
  "kind": "ScalarField",
  "name": "label"
},
v67 = {
  "kind": "ScalarField",
  "name": "prefix"
},
v68 = {
  "concreteType": "ReactionsSummaryResponse",
  "kind": "LinkedField",
  "name": "contentReactionsSummary",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "reactionsCount"
    },
    {
      "kind": "ScalarField",
      "name": "ari"
    },
    {
      "kind": "ScalarField",
      "name": "containerAri"
    },
    {
      "concreteType": "ReactionsSummaryForEmoji",
      "kind": "LinkedField",
      "name": "reactionsSummaryForEmoji",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "emojiId"
        },
        (v65/*: any*/),
        {
          "kind": "ScalarField",
          "name": "reacted"
        },
        (v18/*: any*/)
      ]
    }
  ]
},
v69 = {
  "concreteType": "Content",
  "kind": "LinkedField",
  "name": "ancestors",
  "plural": true,
  "selections": [
    (v18/*: any*/),
    (v27/*: any*/),
    (v62/*: any*/),
    {
      "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "webui"
        }
      ]
    }
  ]
},
v70 = {
  "concreteType": "ClassificationLevelDetails",
  "kind": "LinkedField",
  "name": "classificationLevelDetails",
  "plural": false,
  "selections": [
    {
      "concreteType": "ContentDataClassificationLevel",
      "kind": "LinkedField",
      "name": "classificationLevel",
      "plural": false,
      "selections": [
        (v18/*: any*/),
        {
          "kind": "ScalarField",
          "name": "guideline"
        },
        {
          "kind": "ScalarField",
          "name": "guidelineADF"
        },
        {
          "kind": "ScalarField",
          "name": "description"
        },
        (v23/*: any*/),
        (v22/*: any*/),
        (v19/*: any*/)
      ]
    },
    {
      "kind": "ScalarField",
      "name": "featureEnabled"
    },
    {
      "kind": "ScalarField",
      "name": "source"
    },
    {
      "kind": "ScalarField",
      "name": "isReclassificationPermitted"
    },
    {
      "kind": "ScalarField",
      "name": "canManageSpaceSettings"
    },
    {
      "kind": "ScalarField",
      "name": "classificationControlSetting"
    },
    {
      "kind": "ScalarField",
      "name": "userOverrideSetting"
    }
  ]
},
v71 = {
  "kind": "ScalarField",
  "name": "createdDate"
},
v72 = {
  "concreteType": "ContentProperties",
  "kind": "LinkedField",
  "name": "contentProperties",
  "plural": false,
  "selections": [
    {
      "concreteType": "PublishedContentProperties",
      "kind": "LinkedField",
      "name": "latest",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "generatedBy"
        }
      ]
    }
  ]
},
v73 = {
  "condition": "isSSR",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "MapOfStringToFormattedBody",
      "kind": "LinkedField",
      "name": "macroRenderedOutput",
      "plural": true,
      "selections": [
        (v29/*: any*/),
        {
          "concreteType": "FormattedBody",
          "kind": "LinkedField",
          "name": "value",
          "plural": false,
          "selections": [
            (v25/*: any*/),
            (v45/*: any*/),
            {
              "concreteType": "WebResourceDependencies",
              "kind": "LinkedField",
              "name": "webresource",
              "plural": false,
              "selections": (v48/*: any*/)
            }
          ]
        }
      ]
    }
  ]
},
v74 = {
  "condition": "fetchAgentSessionsMarker",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "agentSessionsMarker",
      "args": [
        {
          "kind": "Variable",
          "name": "key",
          "variableName": "agentSessionsPropertyKey"
        }
      ],
      "concreteType": "PaginatedJsonContentPropertyList",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": (v50/*: any*/)
    }
  ]
},
v75 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "spaceKey"
  }
],
v76 = {
  "kind": "ScalarField",
  "name": "themeKey"
},
v77 = {
  "kind": "ScalarField",
  "name": "background"
},
v78 = {
  "kind": "ScalarField",
  "name": "backgroundColor"
},
v79 = {
  "kind": "ScalarField",
  "name": "backgroundImage"
},
v80 = {
  "kind": "ScalarField",
  "name": "backgroundPosition"
},
v81 = {
  "kind": "ScalarField",
  "name": "backgroundSize"
},
v82 = {
  "kind": "ScalarField",
  "name": "backgroundRepeat"
},
v83 = {
  "kind": "ScalarField",
  "name": "backgroundOrigin"
},
v84 = {
  "kind": "ScalarField",
  "name": "backgroundClip"
},
v85 = {
  "kind": "ScalarField",
  "name": "backgroundAttachment"
},
v86 = {
  "kind": "ScalarField",
  "name": "backgroundBlendMode"
},
v87 = {
  "concreteType": "ScreenLookAndFeel",
  "kind": "LinkedField",
  "name": "screen",
  "plural": false,
  "selections": [
    (v77/*: any*/),
    (v78/*: any*/),
    (v79/*: any*/),
    (v80/*: any*/),
    (v81/*: any*/),
    (v82/*: any*/),
    (v83/*: any*/),
    (v84/*: any*/),
    (v85/*: any*/),
    (v86/*: any*/),
    {
      "concreteType": "LayerScreenLookAndFeel",
      "kind": "LinkedField",
      "name": "layer",
      "plural": false,
      "selections": [
        (v77/*: any*/),
        (v78/*: any*/),
        (v79/*: any*/),
        (v80/*: any*/),
        (v81/*: any*/),
        (v82/*: any*/),
        (v83/*: any*/),
        (v84/*: any*/),
        (v85/*: any*/),
        (v86/*: any*/),
        {
          "kind": "ScalarField",
          "name": "width"
        },
        {
          "kind": "ScalarField",
          "name": "height"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "gutterTop"
    },
    {
      "kind": "ScalarField",
      "name": "gutterRight"
    },
    {
      "kind": "ScalarField",
      "name": "gutterBottom"
    },
    {
      "kind": "ScalarField",
      "name": "gutterLeft"
    }
  ]
},
v88 = {
  "kind": "ScalarField",
  "name": "padding"
},
v89 = {
  "kind": "ScalarField",
  "name": "borderRadius"
},
v90 = {
  "concreteType": "ContainerLookAndFeel",
  "kind": "LinkedField",
  "name": "container",
  "plural": false,
  "selections": [
    (v77/*: any*/),
    (v78/*: any*/),
    (v79/*: any*/),
    (v80/*: any*/),
    (v81/*: any*/),
    (v82/*: any*/),
    (v83/*: any*/),
    (v84/*: any*/),
    (v85/*: any*/),
    (v86/*: any*/),
    (v88/*: any*/),
    (v89/*: any*/)
  ]
},
v91 = {
  "concreteType": "SpaceSettings",
  "kind": "LinkedField",
  "name": "settings",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "routeOverrideEnabled"
    }
  ]
},
v92 = {
  "concreteType": "SpaceUserMetadata",
  "kind": "LinkedField",
  "name": "currentUser",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isAnonymouslyAuthorized"
    }
  ]
},
v93 = [
  (v16/*: any*/),
  {
    "kind": "Variable",
    "name": "limit",
    "variableName": "bylineContributorsLimit"
  }
],
v94 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v95 = [
  (v94/*: any*/),
  (v38/*: any*/)
],
v96 = {
  "kind": "LinkedField",
  "name": "by",
  "plural": false,
  "selections": (v95/*: any*/)
},
v97 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v98 = [
  (v94/*: any*/),
  (v31/*: any*/),
  (v38/*: any*/),
  (v55/*: any*/),
  (v97/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ContentUnifiedQuery",
    "selections": [
      {
        "args": (v17/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v18/*: any*/),
              (v19/*: any*/),
              (v21/*: any*/),
              (v24/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v34/*: any*/),
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v35/*: any*/),
                  (v36/*: any*/),
                  (v37/*: any*/),
                  (v40/*: any*/),
                  (v41/*: any*/),
                  (v42/*: any*/)
                ]
              },
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "draftVersion",
                "plural": false,
                "selections": [
                  (v35/*: any*/),
                  (v36/*: any*/),
                  (v37/*: any*/),
                  (v40/*: any*/),
                  (v41/*: any*/)
                ]
              },
              (v44/*: any*/),
              (v49/*: any*/),
              (v51/*: any*/),
              (v52/*: any*/),
              {
                "kind": "FragmentSpread",
                "name": "ContentOperationsFragment"
              },
              {
                "kind": "FragmentSpread",
                "name": "PageStatusQueryRelaySpike_content"
              },
              {
                "kind": "FragmentSpread",
                "name": "PresenterModePortal_content"
              },
              {
                "condition": "includeArchiveMetadata",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "ArchivedPageBannerV2Status_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "archivedPageBannerStatusFragment"
                  },
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "ArchivedPageBannerV2_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "archivedPageBannerFragment"
                  },
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        (v18/*: any*/),
                        (v31/*: any*/),
                        (v28/*: any*/),
                        (v53/*: any*/),
                        {
                          "concreteType": "History",
                          "kind": "LinkedField",
                          "name": "history",
                          "plural": false,
                          "selections": [
                            {
                              "concreteType": "Version",
                              "kind": "LinkedField",
                              "name": "lastUpdated",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "LinkedField",
                                  "name": "by",
                                  "plural": false,
                                  "selections": [
                                    (v55/*: any*/),
                                    (v56/*: any*/)
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "archivedPageBanner"
                  }
                ]
              },
              {
                "condition": "includeBylineContributors",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "args": [
                            {
                              "kind": "Variable",
                              "name": "useNewContentTopper",
                              "variableName": "useNewContentTopper"
                            }
                          ],
                          "kind": "FragmentSpread",
                          "name": "ContentTitleWithByLine_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "contentTitleWithByLine"
                  }
                ]
              },
              {
                "condition": "useNewContentTopper",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        (v18/*: any*/),
                        (v57/*: any*/),
                        (v58/*: any*/),
                        (v59/*: any*/)
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "titleContentProperties"
                  },
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        (v18/*: any*/),
                        (v60/*: any*/)
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "coverPicture"
                  },
                  (v57/*: any*/)
                ]
              },
              {
                "condition": "includeRestrictions",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        (v18/*: any*/),
                        (v61/*: any*/),
                        (v62/*: any*/),
                        (v63/*: any*/),
                        (v27/*: any*/)
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "shareAndRestrictButtonData"
                  },
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        (v18/*: any*/),
                        (v61/*: any*/),
                        (v63/*: any*/),
                        (v62/*: any*/)
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "pageRestrictionsContext"
                  }
                ]
              },
              {
                "condition": "preloadLabels",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "ViewPageLabelsContentFragment_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "viewPageLabels"
                  },
                  {
                    "args": (v64/*: any*/),
                    "concreteType": "PaginatedLabelList",
                    "kind": "LinkedField",
                    "name": "labels",
                    "plural": false,
                    "selections": [
                      (v65/*: any*/),
                      {
                        "concreteType": "Label",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v18/*: any*/),
                          (v66/*: any*/),
                          (v22/*: any*/),
                          (v67/*: any*/)
                        ]
                      }
                    ],
                    "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
                  }
                ]
              },
              {
                "condition": "includeReactions",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        (v18/*: any*/),
                        (v68/*: any*/)
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "reactionsContent"
                  }
                ]
              },
              {
                "condition": "includeRestrictionAncestors",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        (v18/*: any*/),
                        (v69/*: any*/)
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "pageRestrictionsContextAncestors"
                  }
                ]
              },
              {
                "condition": "includeClassification",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "useContentClassification_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "contentClassificationFragment"
                  },
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        (v18/*: any*/),
                        (v70/*: any*/)
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "contentClassification"
                  }
                ]
              },
              {
                "condition": "includeAgentTrustReceiptData",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      (v71/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": (v39/*: any*/)
                      }
                    ]
                  },
                  (v72/*: any*/)
                ]
              },
              (v73/*: any*/),
              (v74/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v75/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ContentContainerTheme_space"
          },
          {
            "kind": "FragmentSpread",
            "name": "ContentTitle_space"
          },
          (v18/*: any*/),
          {
            "concreteType": "Theme",
            "kind": "LinkedField",
            "name": "theme",
            "plural": false,
            "selections": [
              (v76/*: any*/),
              (v22/*: any*/)
            ]
          },
          {
            "concreteType": "LookAndFeel",
            "kind": "LinkedField",
            "name": "lookAndFeel",
            "plural": false,
            "selections": [
              {
                "concreteType": "ContentLookAndFeel",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v87/*: any*/),
                  (v90/*: any*/)
                ]
              }
            ]
          },
          (v91/*: any*/),
          (v92/*: any*/)
        ]
      },
      {
        "condition": "includeBylineContributors",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v93/*: any*/),
            "concreteType": "ContentContributors",
            "kind": "LinkedField",
            "name": "contentContributors",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "ByLineContributors_contentContributors"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v13/*: any*/),
      (v15/*: any*/),
      (v11/*: any*/),
      (v14/*: any*/),
      (v12/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/),
      (v1/*: any*/),
      (v8/*: any*/),
      (v10/*: any*/),
      (v9/*: any*/),
      (v7/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "ContentUnifiedQuery",
    "selections": [
      {
        "args": (v17/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v18/*: any*/),
              (v31/*: any*/),
              (v28/*: any*/),
              (v19/*: any*/),
              (v27/*: any*/),
              (v52/*: any*/),
              (v21/*: any*/),
              (v24/*: any*/),
              (v26/*: any*/),
              (v30/*: any*/),
              (v32/*: any*/),
              (v34/*: any*/),
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v35/*: any*/),
                  (v36/*: any*/),
                  (v37/*: any*/),
                  (v96/*: any*/),
                  (v41/*: any*/),
                  (v42/*: any*/)
                ]
              },
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "draftVersion",
                "plural": false,
                "selections": [
                  (v35/*: any*/),
                  (v36/*: any*/),
                  (v37/*: any*/),
                  (v96/*: any*/),
                  (v41/*: any*/)
                ]
              },
              (v44/*: any*/),
              (v49/*: any*/),
              (v51/*: any*/),
              {
                "condition": "includeArchiveMetadata",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  (v53/*: any*/),
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "Version",
                        "kind": "LinkedField",
                        "name": "lastUpdated",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "by",
                            "plural": false,
                            "selections": [
                              (v94/*: any*/),
                              (v55/*: any*/),
                              (v56/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "condition": "includeBylineContributors",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": "emojiTitlePublished",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "key",
                        "value": "emoji-title-published"
                      }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": (v50/*: any*/),
                    "storageKey": "properties(key:\"emoji-title-published\")"
                  },
                  {
                    "alias": "editorProperty",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "key",
                        "value": "editor"
                      }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JsonContentProperty",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v18/*: any*/),
                          (v29/*: any*/),
                          (v25/*: any*/)
                        ]
                      }
                    ],
                    "storageKey": "properties(key:\"editor\")"
                  },
                  {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "homepageId"
                      }
                    ]
                  },
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      (v71/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": (v98/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "name": "ownedBy",
                        "plural": false,
                        "selections": (v98/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "name": "lastOwnedBy",
                        "plural": false,
                        "selections": (v98/*: any*/)
                      }
                    ]
                  },
                  {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "by",
                        "plural": false,
                        "selections": [
                          (v31/*: any*/),
                          (v97/*: any*/),
                          (v55/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v72/*: any*/),
                  {
                    "condition": "useNewContentTopper",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v57/*: any*/)
                    ]
                  }
                ]
              },
              {
                "condition": "useNewContentTopper",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  (v57/*: any*/),
                  (v58/*: any*/),
                  (v59/*: any*/),
                  (v60/*: any*/)
                ]
              },
              {
                "condition": "includeRestrictions",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  (v61/*: any*/),
                  (v62/*: any*/),
                  (v63/*: any*/)
                ]
              },
              {
                "condition": "preloadLabels",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "args": (v64/*: any*/),
                    "concreteType": "PaginatedLabelList",
                    "kind": "LinkedField",
                    "name": "labels",
                    "plural": false,
                    "selections": [
                      (v65/*: any*/),
                      {
                        "concreteType": "Label",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v94/*: any*/),
                          (v18/*: any*/),
                          (v66/*: any*/),
                          (v22/*: any*/),
                          (v67/*: any*/)
                        ]
                      }
                    ],
                    "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
                  }
                ]
              },
              {
                "condition": "includeReactions",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  (v68/*: any*/)
                ]
              },
              {
                "condition": "includeRestrictionAncestors",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  (v69/*: any*/)
                ]
              },
              {
                "condition": "includeClassification",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  (v70/*: any*/)
                ]
              },
              {
                "condition": "includeAgentTrustReceiptData",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      (v71/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": (v95/*: any*/)
                      }
                    ]
                  },
                  (v72/*: any*/)
                ]
              },
              (v73/*: any*/),
              (v74/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v75/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          {
            "concreteType": "Theme",
            "kind": "LinkedField",
            "name": "theme",
            "plural": false,
            "selections": [
              (v22/*: any*/),
              (v76/*: any*/)
            ]
          },
          {
            "concreteType": "LookAndFeel",
            "kind": "LinkedField",
            "name": "lookAndFeel",
            "plural": false,
            "selections": [
              {
                "concreteType": "ContentLookAndFeel",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v87/*: any*/),
                  (v90/*: any*/),
                  {
                    "concreteType": "ContainerLookAndFeel",
                    "kind": "LinkedField",
                    "name": "header",
                    "plural": false,
                    "selections": [
                      (v77/*: any*/),
                      (v85/*: any*/),
                      (v86/*: any*/),
                      (v84/*: any*/),
                      (v78/*: any*/),
                      (v79/*: any*/),
                      (v83/*: any*/),
                      (v80/*: any*/),
                      (v82/*: any*/),
                      (v81/*: any*/),
                      (v89/*: any*/),
                      (v88/*: any*/)
                    ]
                  }
                ]
              },
              {
                "concreteType": "MapOfStringToString",
                "kind": "LinkedField",
                "name": "headings",
                "plural": true,
                "selections": (v33/*: any*/)
              }
            ]
          },
          (v18/*: any*/),
          (v91/*: any*/),
          (v92/*: any*/)
        ]
      },
      {
        "condition": "includeBylineContributors",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v93/*: any*/),
            "concreteType": "ContentContributors",
            "kind": "LinkedField",
            "name": "contentContributors",
            "plural": false,
            "selections": [
              (v65/*: any*/),
              {
                "kind": "ScalarField",
                "name": "isCurrentUserContributor"
              },
              {
                "kind": "ScalarField",
                "name": "isOwnerContributor"
              },
              {
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": (v98/*: any*/)
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "ecbd6fa17ec00de4901cd6f361c8e5a7",
    "id": "b106f8974443976a3ba89da95c938ac40473dc9d075a7590278530c4bec67053",
    "metadata": {},
    "name": "ContentUnifiedQuery",
    "operationKind": "query",
    "text": "query ContentUnifiedQuery($contentId:ID!,$spaceKey:String=null,$versionOverride:Int,$isSSR:Boolean=false,$useNewContentTopper:Boolean=false,$preloadLabels:Boolean=false,$agentSessionsPropertyKey:String=\"\",$fetchAgentSessionsMarker:Boolean=false,$includeAgentTrustReceiptData:Boolean=false,$includeBylineContributors:Boolean=false,$bylineContributorsLimit:Int,$includeReactions:Boolean=false,$includeRestrictions:Boolean=false,$includeRestrictionAncestors:Boolean=false,$includeClassification:Boolean=false,$includeArchiveMetadata:Boolean=false)@allowHigherTimeout{content(id:$contentId,version:$versionOverride){nodes{...ContentOperationsFragment,...PageStatusQueryRelaySpike_content,...PresenterModePortal_content,id,status,...ArchivedPageBannerV2Status_content@include(if:$includeArchiveMetadata)\n      ...ArchivedPageBannerV2_content@include(if:$includeArchiveMetadata)\n      id@include(if:$includeArchiveMetadata)\n      type@include(if:$includeArchiveMetadata)\n      operations@include(if:$includeArchiveMetadata){operation,targetType}\n      archivedContentMetadata@include(if:$includeArchiveMetadata){archiveNote}\n      history@include(if:$includeArchiveMetadata){lastUpdated{by{__typename,...on KnownUser{accountId},...on UnknownUser{accountId}}}},contentProperties{latest{contentMode},draft{contentMode}},contentState(isDraft:false){id,name,color,restrictionLevel},contentStateLastUpdated(format:USER_FRIENDLY){value},...ContentTitleWithByLine_content_2SjeOj@include(if:$includeBylineContributors),title,operations{operation,targetType},space{id,name,key,alias},type,subType,smartFolderProperties:properties(keys:[\"smartFolderProperties\"]){nodes{key,value}},version{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when,confRev,when@include(if:$includeAgentTrustReceiptData)},draftVersion{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when},metadata{frontend{fabricEditorSupported,embedded,collabService,coverPictureWidth@include(if:$useNewContentTopper)},lastModifiedDate},id@include(if:$useNewContentTopper)\n      pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}}\n      pageTitleDraft:properties(key:\"page-title-property-draft\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}}\n      metadata@include(if:$useNewContentTopper){frontend{coverPictureWidth}}\n      coverPictureProperties:properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"])@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},id@include(if:$includeRestrictions)\n      hasInheritedRestrictions@include(if:$includeRestrictions)\n      hasRestrictions@include(if:$includeRestrictions)\n      hasViewRestrictions@include(if:$includeRestrictions)\n      title@include(if:$includeRestrictions),...ViewPageLabelsContentFragment_content@include(if:$preloadLabels)\n      labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING})@include(if:$preloadLabels){count,nodes{id,label,name,prefix}},id@include(if:$includeReactions)\n      contentReactionsSummary@include(if:$includeReactions){reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}},id@include(if:$includeRestrictionAncestors)\n      ancestors@include(if:$includeRestrictionAncestors){id,title,hasRestrictions,links{webui}},...useContentClassification_content@include(if:$includeClassification)\n      id@include(if:$includeClassification)\n      classificationLevelDetails@include(if:$includeClassification){classificationLevel{id,guideline,guidelineADF,description,color,name,status},featureEnabled,source,isReclassificationPermitted,canManageSpaceSettings,classificationControlSetting,userOverrideSetting},body{dynamic{representation,value,content{id,version{number}},webresource{superbatch{tags{js,css}},tags{js,css}}}},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"]){nodes{id,key,value,version{number}}},history@include(if:$includeAgentTrustReceiptData){createdDate,createdBy{__typename,displayName}}\n      contentProperties@include(if:$includeAgentTrustReceiptData){latest{generatedBy}},macroRenderedOutput@include(if:$isSSR){key,value{value,representation,webresource{tags{js,css}}}},agentSessionsMarker:properties(key:$agentSessionsPropertyKey)@include(if:$fetchAgentSessionsMarker){nodes{id,key,value,version{number}}}}},contentContributors(id:$contentId,limit:$bylineContributorsLimit)@include(if:$includeBylineContributors){...ByLineContributors_contentContributors},space(key:$spaceKey){...ContentContainerTheme_space,...ContentTitle_space,id,theme{themeKey,name},lookAndFeel{content{screen{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,layer{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,width,height},gutterTop,gutterRight,gutterBottom,gutterLeft},container{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius}}},settings{routeOverrideEnabled},currentUser{isAnonymouslyAuthorized}}}fragment ArchivedPageBannerV2Status_content on Content{id,status}fragment ArchivedPageBannerV2_content on Content{id,type,operations{operation,targetType},archivedContentMetadata{archiveNote},history{lastUpdated{by{__typename,...on KnownUser{accountId},...on UnknownUser{accountId}}}}}fragment ByLineContributors_contentContributors on ContentContributors{count,isCurrentUserContributor,isOwnerContributor,nodes{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}}fragment ByLine_content_2SjeOj on Content{...useReadTime_content,id,type,subType,history{createdDate,createdBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},ownedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},lastOwnedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}},version{by{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},friendlyWhen,when,number,contentTypeModified},contentProperties{latest{generatedBy}},...RendererContentState_content,pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},editorProperty:properties(key:\"editor\"){nodes{id,key,value}},metadata{frontend{coverPictureWidth@include(if:$useNewContentTopper)}}}fragment ContentContainerTheme_space on Space{theme{name,themeKey},lookAndFeel{content{screen{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,layer{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,width,height},gutterTop,gutterRight,gutterBottom,gutterLeft},container{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius}}}}fragment ContentOperationsFragment on Content{id,type,operations{operation,targetType}}fragment ContentTitleWithByLine_content_2SjeOj on Content{...ContentTitle_content_2SjeOj,...ByLine_content_2SjeOj,...ArchivedPageBannerV2Status_content}fragment ContentTitle_content_2SjeOj on Content{id,type,title,appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value,version{number}}},pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},editorProperty:properties(key:\"editor\"){nodes{id,key,value}},metadata{frontend{fabricEditorSupported,coverPictureWidth@include(if:$useNewContentTopper)}},space{id,name,homepageId}}fragment ContentTitle_space on Space{id,theme{themeKey},lookAndFeel{headings{key,value},content{header{background,backgroundAttachment,backgroundBlendMode,backgroundClip,backgroundColor,backgroundImage,backgroundOrigin,backgroundPosition,backgroundRepeat,backgroundSize,borderRadius,padding}}}}fragment PageStatusQueryRelaySpike_content on Content{status}fragment PresenterModePortal_content on Content{title,properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"]){nodes{id,key,value,version{number}}}}fragment RendererContentState_content on Content{id,contentState(isDraft:false){id,name,color,restrictionLevel},contentStateLastUpdated(format:USER_FRIENDLY){value}}fragment ViewPageLabelsContentFragment_content on Content{id,type,status,operations{operation,targetType},space{id},labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING}){count,nodes{__typename,id,label,name,prefix}}}fragment useContentClassification_content on Content{id,classificationLevelDetails{classificationLevel{id,guideline,guidelineADF,description,color,name,status},featureEnabled,source,isReclassificationPermitted,canManageSpaceSettings,classificationControlSetting,userOverrideSetting}}fragment useReadTime_content on Content{id,type,body{dynamic{value,representation}},operations{operation,targetType}}"
  }
};
})();

(node as any).hash = "c53f6ba341463403b6644e692a98b552";

export default node;
